export enum ToolsPermissions {
  Tool = 'tool',
}
